import React, { useContext } from 'react';
import {
  Button,
  Card,
  CardHeader,
  CardSection,
  Grid,
  GridColumn,
  GridRow,
  Gutter,
  Layout,
  PageContext,
  Paragraph,
  SmallHeader,
  useApi,
  useBreakpoint,
  Visible,
  Well,
} from '@axiom/ui';

import SpyGlasses from '../public/svg/spy-glasses.svg';
import { UserApi } from '../api/user-api';

export const ForbiddenPage = () => {
  const [{ data: user } = { data: null }] = useApi(UserApi.readUser());
  const accountId = user?.contact?.accounts?.[0]?.id ?? null;
  const url = `/account${accountId ? `/${accountId}/my-engagements` : ''}`;
  const { isMobile } = useBreakpoint();

  const { setTitle } = useContext(PageContext);
  setTitle('AxiomLaw - Unauthorized');
  return (
    <Card name="FORBIDDEN_PAGE">
      <CardHeader>
        <SmallHeader name="HEADER_MESSAGE">
          Looks like you do not have permissions to view this account or
          engagement.
        </SmallHeader>
      </CardHeader>
      <CardSection>
        <Grid stackable>
          <GridRow columns={2}>
            <GridColumn>
              <Well>
                <Layout position="center">
                  <SpyGlasses
                    name="SPY_GLASSES"
                    width={isMobile ? '99' : '212'}
                    height={isMobile ? '100' : '215'}
                  />
                </Layout>
              </Well>
              <Visible only="mobile">
                <Gutter bottom="16px" />
              </Visible>
            </GridColumn>
            <GridColumn>
              <Grid>
                <GridRow gutterBottom="24px">
                  <GridColumn>
                    <Paragraph name="FIRST_PARAGRAPH">
                      Sorry, it looks like you do not have permissions to view
                      this account or specific engagement.
                    </Paragraph>
                  </GridColumn>
                </GridRow>
                <GridRow gutterBottom="24px">
                  <GridColumn>
                    <Paragraph name="SECOND_PARAGRAPH">
                      You can continue to the engagements screen in your Axiom
                      client account to view all engagements you currently have
                      access to.
                    </Paragraph>
                  </GridColumn>
                </GridRow>
                <GridRow>
                  <GridColumn>
                    <Button to={url} name="CONTINUE" fluid={isMobile}>
                      Continue to my engagements
                    </Button>
                  </GridColumn>
                </GridRow>
              </Grid>
            </GridColumn>
          </GridRow>
        </Grid>
      </CardSection>
    </Card>
  );
};
